import Base from '@/assets/js/baseFun'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'


export default {
wxBuildUrl(url){

let appId = 'wxfa5fbf9793cfa1c2'
let weChatSplicingHalf = 'https://open.weixin.qq.com/connect/oauth2/authorize?appId=';
let wechatSplicingOther = '&response_type=code&scope=snsapi_userinfo&connect_redirect=1#wechat_redirect';

let shortUrl1 = weChatSplicingHalf + appId + '&redirect_uri=' + encodeURIComponent(url) + wechatSplicingOther
return shortUrl1
},
wxConfigBuild(userID,title,description,link,imgUrl){
let wx = WechatPlugin.$wechat;
Base.baseAjax({
url:'/pay/url/get',
showLoading:true,
type:'post',
data:{
"type":"product",
"url":location.href.split('#')[0],
"proxy":userID,
"subType":"",
"channelID":""
},
success:function(data){
wx.config({
debug:false,
appId:'wxfa5fbf9793cfa1c2',
timestamp:data.timestamp,
nonceStr:data.nonceStr,
signature:data.signature,
jsApiList:[
'onMenuShareAppMessage',
'onMenuShareTimeline',
]
});

wx.ready(() => {

wx.onMenuShareAppMessage({
title: title,
desc: description,
link:link,
imgUrl: imgUrl,
success: function (res) {

},
error:function (err) {

}
});


wx.onMenuShareTimeline({
title: title,

link:link,
imgUrl: imgUrl,
success: function (res) {

},
error:function (err) {

}
});

});
}
})
},
wxConfigBuild_in(title,desc,linkUrl,imgUrl){
let wx = WechatPlugin.$wechat;
Base.baseAjax({
url:'/h5/weChatJsSignature',
showLoading:false,
type:'post',
data:{
"url":location.href.split('#')[0],
},
success:function(data){
console.log(data)
wx.config({
debug:false,
appId:'wx169c2851d92b6bd8',
timestamp:data.timestamp,
nonceStr:data.nonceStr,
signature:data.signature,
jsApiList:[
'onMenuShareAppMessage',
'onMenuShareTimeline',
]
});

wx.ready(() => {

wx.onMenuShareAppMessage({
title: title,
desc: desc,
link: linkUrl,
imgUrl: imgUrl,
success: function (res) {

},
error:function (err) {

}
});


wx.onMenuShareTimeline({
title: title,
link: linkUrl,
imgUrl: imgUrl,
success: function (res) {

},
error:function (err) {

}
});

});
}
})
},
isWeiXin(){
let ua = navigator.userAgent.toLowerCase();
if(ua.match(/MicroMessenger/i) == 'micromessenger'){
return true;
}else{
return false;
}
}


}




// WEBPACK FOOTER //
// ./src/assets/js/wx_config.js